import { ChakraV3 } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { MdBarChart, MdOutlineSsidChart, MdScatterPlot } from 'react-icons/md';
import type { ChartType } from '../../utils';

interface Props {
  chartType: ChartType;
  color?: string;
  size?: number;
}

export const ChartTypeIcon = (props: Props) => {
  const Icon = P.run(() => {
    switch (props.chartType) {
      case 'BarTimeSeries':
        return MdBarChart;
      case 'LineTimeSeries':
        return MdOutlineSsidChart;
      case 'ScatterTimeSeries':
        return MdScatterPlot;
    }
  });

  return (
    <ChakraV3.Icon boxSize={`${props.size}px`} color={props.color}>
      <Icon size={props.size ?? 16} />
    </ChakraV3.Icon>
  );
};
